export const getCustomersAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_CUSTOMER_DETAILS":
      return action.data;

    default:
      return state;
  }
};
